/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react';
import { checkViewPermission } from '../../../../../helpers/utilities';
import { useDispatch, useSelector } from "react-redux";
import crudActions from "../../../../CRUD/redux/actions";
import { DiscountCustomTable, DiscountTopBar, DiscountCustomForm } from "./Discount";
import moment from 'moment';
import usePrevious from "../../../../Shared/components/Previous";
import { toast } from 'react-toastify';
import actions from "../../redux/actions";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import unitActions from "../../../../Product/Setup/redux/actions";
import { emptyValidation } from "../../../../../helpers/validation";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import productActions from "../../../../Product/Product/redux/actions";


const SalesDiscount = React.forwardRef((props, ref) => {
    const { createDetails, createError, editDetails, editError, createData } = useSelector(state => state.crudReducer);
    const { heads, title, topBarView, customerId, groupId, roleManagement, history } = props;
    const { salesDiscountDetails, salesDiscountLoader } = useSelector(state => state.productSetupReducer);

    const [topBar, setTopBar] = useState({
        type: 'ALL',
        status: "active"
    });

    const { getList, getData } = useSelector(state => state.crudReducer);
    const [deleteModal, setDeleteModal] = useState(false);
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const dispatch = useDispatch();
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [importVisible, setImportVisible] = useState(false);
    const [form, setForm] = useState({});
    const [productDetails, setProductDetails] = useState({});
    const [priceId, setPriceId] = useState('');

    const [visible, setVisible] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const [error, setError] = useState({});
    const [commonError, setCommonError] = useState(false);
    const [view, setView] = useState(false);

    const [skip, setSkip] = useState(0);
    const limit = 25;

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Sales Discount', history, 'Sales')) {
                dispatch({
                    type: unitActions.UNITMESUREMENT_DETAILS_START, url: 'unit', filter: {
                        order: 'id desc'
                    }
                });
                productApi();
            }
        }
    }, [roleManagement]);

    const productApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ status: 'ACTIVE' }, { ["or"]: [{ transType: { eq: null } }, { transType: { eq: 'SALES' } }] }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ productName: { like: '%' + search.trim() + '%' } });
            or['or'].push({ description: { like: '%' + search.trim() + '%' } });
            or['or'].push({ productId: { like: '%' + search.trim() + '%' } });
            or['or'].push({ barcode: { like: '%' + search.trim() + '%' } });
            or['or'].push({ code: { like: '%' + search.trim() + '%' } });
        }

        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);
        dispatch({
            type: productActions.MYPRODUCT_DETAILS_START, url: 'client-products',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Customer Sales Discount', history, 'Sales')) {
                dispatchFilter(sortBy, sortOrder);
            }
        }
    }, [topBar, roleManagement]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { "and": [] };
        let or = { "or": [] }
        if (topBar?.productId) {
            filter['and'].push({ productId: topBar?.productId });
        }

        if (topBar?.startDate && topBar?.endDate) {
            filter['and'].push({ fromDate: { gte: moment(topBar?.startDate).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(topBar?.endDate).format('YYYY-MM-DD') } });
        }

        if (topBar?.customerId || customerId) {
            if (customerId) {
                if (groupId) {
                    or['or'].push({ customerGroupId: groupId });
                }
                or['or'].push({ customerId: customerId });
            } else {
                filter['and'].push({ customerId: topBar?.customerId });
            }
        }


        if (topBar?.search && topBar?.search !== '') {
            or['or'].push({ priceId: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ priceSpec: { like: '%' + topBar?.search.trim() + '%' } });
            or['or'].push({ customerSpec: { like: '%' + topBar?.search.trim() + '%' } });
        }

        if (topBar?.customerSpec && topBar?.customerSpec !== '') {
            filter['and'].push({ customerSpec: topBar?.customerSpec });
        }

        if (topBar?.customerGroupId) {
            filter['and'].push({ customerGroupId: topBar?.customerGroupId });
        }

        if (topBar?.status) {
            filter['and'].push({ isActive: topBar?.status === 'active' ? true : false });
        }
        filter['and'].push(or);
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'sales-discounts',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const handleEmpty = (d) => {
        setVisible(d);
        setError({});
        setView(false);
        setForm({
            priceSpec: 'SALES DISCOUNT',
            priceId: "blank",
            productSpec: "SPECIFIC", minQty: 1,
            customerSpec: 'ALL', isActive: true
        });
        productApi();
        setPriceId('');
        setProductDetails({});
        setCommonError(false);
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const changeTopHandler = (value, name) => {
        if (name === 'type' && (value === 'ALL' || value === 'SPECIFIC' || value === 'GROUP')) {
            setTopBar({
                ...topBar,
                [name]: value,
                customerId: '',
                customerGroupId: '',
                customerSpec: value !== 'ALL' ? value : ''
            })
        } else if (name === 'dateFilter') {
            setTopBar({
                ...topBar,
                'startDate': '', 'endDate': '',
            })
        } else {
            setTopBar({
                ...topBar,
                [name]: value
            })
        }
    }

    const handleMobileFilter = (data) => {
        setTopBar(data);

    }
    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const onEdit = (data) => {
        setForm(data);
        setPriceId(data?.id);
        productApi('', data?.productId);
        setProductDetails(data?.product);
        setVisible(true);
    }

    const onView = (data) => {
        setForm(data);
        setPriceId(data?.id);
        setProductDetails(data?.product);
        productApi('', data?.productId);
        setVisible(true);
        setView(true);
    }

    const onDelete = (data) => {
        setForm(data);
        setPriceId(data?.id);
        setDeleteModal(true);
    }

    const handleDeactive = (data) => {
        dispatch({
            type: crudActions.EDIT_DETAILS_START,
            url: 'sales-discounts',
            title: "Sales Discounts",
            id: data?.id,
            details: {
                'isActive': !data?.isActive
            }
        })
    }

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            if (createData?.error?.message) {
                setCommonError(createData?.error?.message);
            } else {
                toast.dismiss();
                toast(createDetails);
                handleEmpty(false); dispatchFilter(sortBy, sortOrder);
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let message = createError.error.message;
            setCommonError(message);
        }
    }, [createDetails, createError]);

    useEffect(() => {
        if (!customerId && prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            toast.dismiss();
            toast(editDetails);
            handleEmpty(false); dispatchFilter(sortBy, sortOrder);
        } else if (!customerId && prevEditError !== undefined && editError && prevEditError !== editError) {
            let message = editError?.error?.message;
            setCommonError(message);
        }
    }, [editDetails, editError]);

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx', exportType = 'export') => {
        let filter = { "and": [] };

        if (topBar?.productId) {
            filter['and'].push({ productId: topBar?.productId });
        }

        if (topBar?.startDate && topBar?.endDate) {
            filter['and'].push({ fromDate: { gte: moment(topBar?.startDate).format('YYYY-MM-DD') } });
            filter['and'].push({ toDate: { lte: moment(topBar?.endDate).format('YYYY-MM-DD') } });
        }

        if (topBar?.customerId) {
            filter['and'].push({ customerId: topBar?.customerId });
        }

        if (topBar?.customerSpec && topBar?.customerSpec !== '') {
            filter['and'].push({ customerSpec: topBar?.customerSpec });
        }

        if (topBar?.customerGroupId) {
            filter['and'].push({ customerGroupId: topBar?.customerGroupId });
        }

        if (topBar?.status) {
            filter['and'].push({ isActive: topBar?.status === 'active' ? true : false });
        }

        dispatch({
            type: actions.SALES_DISCOUNT_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            exportType: exportType,
            url: 'sales-discounts',
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            if (name === 'productSpec') {
                setProductDetails({});
                if (e === 'SPECIFIC') {
                    setForm({
                        ...form,
                        [name]: e,
                        productGroupId: '', unitId: ''
                    });
                } else {
                    setForm({
                        ...form,
                        [name]: e,
                        productId: '', unitId: ''
                    });
                }
            } else {
                setForm({
                    ...form,
                    [name]: e,
                });
            }
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    }

    const handleCopy = (data) => {
        setView(false);
        setForm({ ...data });
        setPriceId('');
        setVisible(true);
    }
    const handleProductChange = (data) => {
        setForm({
            ...form,
            'productId': data?.id,
            'unitId': data?.salesUnitId
        });
        setError({});
        setProductDetails(data);
    }

    const customObject = (details, id) => {
        let a = details && details.filter(function (el) { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let emptyProductId = { isValid: true, errors: '' };

        let emptyProductGroupId = { isValid: true, errors: '' };
        let emptyCustomerId = { isValid: true, errors: '' };
        let emptyCustomerGroupId = { isValid: true, errors: '' };
        let emptyMinQty = emptyValidation('Minimum Quantity', form?.minQty);


        if (form?.productSpec === 'SPECIFIC') {
            emptyProductId = emptyValidation('Product', form?.productId, 'dropDown');
        } else {
            emptyProductGroupId = emptyValidation('Product Group', form?.productGroupId, 'dropDown');
        }

        let emptyUnitId = emptyValidation('Unit', form?.unitId, 'dropDown');
        let emptyDiscountAmount = emptyValidation('Discount Amount', form?.discountAmount);
        let emptyDiscountPercentage = emptyValidation('Discount Percentage', form?.discountPercent);
        let amount = true;

        let date = true;
        let fromDate = moment(form?.fromDate).format("YYYY-MM-DD");
        let toDate = moment(form?.toDate).format("YYYY-MM-DD");
        if (form?.fromDate && form?.toDate) {
            if (moment(toDate).diff(moment(fromDate), 'days') < 0) {
                date = false;
            }
        }

        if (form?.customerSpec === 'SPECIFIC') {
            emptyCustomerId = emptyValidation('Customer', form?.customerId, 'dropDown');
        } else if (form?.customerSpec === 'GROUP') {
            emptyCustomerGroupId = emptyValidation('Customer Group', form?.customerGroupId, 'dropDown');
        }

        if (emptyDiscountAmount?.errors && emptyDiscountPercentage?.errors) {
            amount = false;
        }
        let discountAmount = true;
        if (form?.discountAmount && productDetails?.mrp && form?.discountAmount > productDetails?.mrp) {
            discountAmount = false;
        }

        let discountPercentage = true;
        if (form?.discountPercent && form?.discountPercent > 100) {
            discountPercentage = false;
        }

        setError({});
        if (emptyProductId.isValid && date && emptyProductGroupId.isValid && emptyUnitId.isValid &&
            emptyCustomerId.isValid && emptyCustomerGroupId.isValid && emptyMinQty.isValid && amount && discountAmount && discountPercentage) {
            delete form.id;
            delete form.unit;
            delete form.product;
            delete form.customer;
            delete form.customerGroup;
            delete form.productGroup;
            let data = Object.fromEntries(Object.entries(form).filter(([_, v]) => v !== null && v !== ''));

            if (data?.fromDate) {
                data.fromDate = moment(data?.fromDate).format("YYYY-MM-DD")
            }

            if (data?.toDate) {
                data.toDate = moment(data?.toDate).format("YYYY-MM-DD")
            }

            if (data?.discountPercent) {
                data.discountPercent = parseFloat(data.discountPercent);
            }

            if (data?.discountAmount) {
                data.discountAmount = parseFloat(data.discountAmount);
            }

            if (data?.minQty) {
                data.minQty = parseFloat(data.minQty);
            }

            dispatch({
                type: priceId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                //type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "sales-discounts",
                title: "Sales Discount",
                method: "put",
                id: priceId,
                details: data
            })
        } else {
            setError({
                'productId': emptyProductId.errors,
                'productGroupId': emptyProductGroupId.errors,
                'unitId': emptyUnitId.errors,
                'discountPercent': !discountPercentage ? "Discount Percenatge cannot be greater than 100" : '',
                'discountAmount': !amount ? 'Discount Amount cannot be blank' : (!discountAmount ? 'Discount amount is greater than MRP, please correct it.' : ''),
                'minQty': emptyMinQty.errors,
                'customerId': emptyCustomerId.errors,
                'customerGroupId': emptyCustomerGroupId.errors,
                'toDate': date ? '' : 'To date is not lesser than from date'
            })
        }
    }

    return (
        <React.Fragment>
            <DiscountTopBar {...props}
                handleCreate={() => handleEmpty(true)}
                topBarView={topBarView}
                onImportVisible={(v) => setImportVisible(v)}
                roleManagement={roleManagement}
                topBar={topBar}
                title={title}
                loadImportExportData={(name) => loadImportExportData(name)}
                changeHandler={(value, name) => changeTopHandler(value, name)}
                handleMobileFilter={(data) => handleMobileFilter(data)}
                productApi={(s = '', id = '') => productApi(s, id)}
            />
            <DiscountCustomTable
                {...props}
                heads={heads}
                loadMore={loadMore}
                loadMoreTask={() => loadMoreTask()}
                loadMoreContent={loadMoreContent}
                type={customerId ? 'singleCustomer' : topBar?.type}
                details={customerId ? getList && getList?.filter((item) => {
                    return item.fromDate > moment().format('YYYY-MM-DD') || item.toDate > moment().format('YYYY-MM-DD') || item.toDate === null || item.fromDate === null;
                }) : getList}
                topBar={topBar}
                roleManagement={roleManagement}
                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                onEdit={(data) => onEdit(data)}
                onView={(data) => onView(data)}
                onDelete={(data) => onDelete(data)}
                sortBy={sortBy}
                sortOrder={sortOrder}
                handleDeactive={(data) => handleDeactive(data)}
                handleCopy={(data) => { handleCopy(data) }}
            />
            <DiscountCustomForm
                commonError={commonError}
                priceId={priceId}
                roleManagement={roleManagement}
                changeHandler={(e, fieldName) => changeHandler(e, fieldName)}
                handleProductChange={(data) => handleProductChange(data)}
                handleIsActive={(data) => setForm({ ...form, "isActive": data })}
                form={{ ...form }}
                productDetails={productDetails}
                title={title}
                view={view}
                error={{ ...error }}
                customObject={(details, id) => customObject(details, id)}
                handleSubmit={(e) => handleSubmit(e)}
                handleClose={() => handleEmpty(false)} visible={visible}
                handleEdit={(d) => setView(d)}
                productApi={(s = '', id = '') => productApi(s, id)}
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={priceId} loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                name={form?.priceId} url={'sales-discounts'}
                title={'Sales Discounts'} visible={deleteModal}
            />
            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={"Customer Sales Discount"}
                type={'import'}
                loader={salesDiscountLoader}
                loadImportExportData={(name, type, selected, extension, exportType) => loadImportExportData(name, type, selected, extension, exportType)}
                details={salesDiscountDetails}
                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
            />
        </React.Fragment>
    )
})

export default SalesDiscount;